import { render } from "./EmailCreate.vue?vue&type=template&id=005956f0"
import script from "./EmailCreate.vue?vue&type=script&lang=js"
export * from "./EmailCreate.vue?vue&type=script&lang=js"
script.render = render

export default script